export const TERMSOFUSE =
    'https://click.alfabank.ru/cs/groups/public/documents/document/' +
    'polzov_soglachenie.pdf?previewDocument';
export const TERMSOFUSEANDROID =
    'https://click.alfabank.ru/cs/groups/public/documents/document/termsofuse.html';
export const CARDISSUE =
    'https://click.alfabank.ru/cs/groups/public/documents/document/cardissue.pdf?previewDocument';
export const CARDISSUEANDROID =
    'https://click.alfabank.ru/cs/groups/public/documents/document/agreement.html';
